@if (caseDetails) {
  <div
    class="complex-list-case-details-row"
    #row2
    ftrTooltip
    [template]="caseDetailsTemplate"
    [templateContext]="{ $implicit: caseDetails }"
    [showDash]="false"
    [forceDisplayState]="isElementTruncated(row2) ? undefined : tooltipDisplay.Hide"
  >
    <ng-container *ngTemplateOutlet="caseDetailsTemplate; context: { $implicit: caseDetails }"></ng-container>
  </div>
}

<ng-template #caseDetailsTemplate let-caseDetails>
  <span class="jobs-list-item__case-number light">{{ caseDetails.caseNumber }}</span> •
  <strong class="jobs-list-item__case-title">{{ caseDetails.caseTitle }}</strong>
</ng-template>
